export default function CtaSection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20editorial%20product%20photography%20of%20a%20sweeping%20flatlay%20arrangement%20of%20premium%20fashion%20items%20including%20leather%20bags%20designer%20shoes%20elegant%20accessories%20and%20folded%20garments%20spread%20across%20a%20warm%20cream%20textured%20surface%20with%20beautiful%20soft%20natural%20window%20light%2C%20magazine%20quality%2C%20rich%20neutral%20earthy%20palette%2C%20professional%20commercial%20photography%2C%20clean%20elegant%20composition&width=1920&height=800&seq=cta-bg-v2-mulebuy-02&orientation=landscape"
          alt="Mulebuy spreadsheet complete product directory"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
            <div className="lg:max-w-xl">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold text-background-50 leading-tight mb-4">
                Start exploring the most complete mulebuy spreadsheet database now
              </h2>
              <p className="text-background-50/75 text-base leading-relaxed max-w-md">
                Access verified product lists across all categories. No sign-up required — just click and explore.
              </p>
            </div>

            <div className="flex flex-col gap-4 lg:items-end">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-background-50 text-foreground-900 font-semibold text-base hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap group"
              >
                <span>Explore Full Directory</span>
                <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                  <i className="ri-arrow-right-line text-background-50 text-sm"></i>
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                Or visit the main website directly <i className="ri-arrow-right-up-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}